import createAction from 'redux-actions/es/createAction';

export const verifyEmailRequest = createAction('VERIFY_EMAIL_REQUEST');
export const verifyEmailSuccess = createAction('VERIFY_EMAIL_SUCCESS');
export const verifyEmailFail = createAction('VERIFY_EMAIL_FAIL');

export const sendVerificationEmailRequest = createAction('SEND_VERIFICATION_EMAIL_REQUEST');
export const sendVerificationEmailSuccess = createAction('SEND_VERIFICATION_EMAIL_SUCCESS');
export const sendVerificationEmailFail = createAction('SEND_VERIFICATION_EMAIL_FAIL');
